// 独立入口参数不复用商品链接的orgId，避免把供货机构误作当前店铺。
export function requestedShopOrgId(href:string):number|undefined{
  const url=new URL(href)
  if(!url.searchParams.has('shopOrgId'))return undefined
  const values=url.searchParams.getAll('shopOrgId'),raw=values[0]
  if(values.length!==1 || !/^\d+$/.test(raw) || !Number.isSafeInteger(Number(raw)) || Number(raw)<1000)throw new Error('当前店铺入口无效，请重新打开本店入口')
  return Number(raw)
}

export function shopSessionMismatch(requested:number|undefined,user?:{id?:number;orgId?:number}):boolean {
  return requested!==undefined && Boolean(user?.id) && Number(user?.orgId)!==requested
}
